let utils = require('../../../actions/utils');
let analytics = require('../../../actions/analytics');
let auth = require('../../../actions/auth');
let cookie = require('../../../actions/cookie');
let page = require('../../../actions/page');
let restore = require('../../../actions/auth/restore-password');
let footer = require('../../../actions/layout/footer');
let seo = require('../../../actions/seo');

module.exports = [
    analytics.parseUtmFromQuery,
    utils.set('layout', 'auth'),
    cookie.checkExistCookie, {
        exist: [
            utils.set(['page', 'name'], 'alert'),
            utils.set(['auth', 'alert', 'type'], 'redirect')
        ],
        notExist: [
            page.setCurrentPage
        ]
    },
    seo.setDashboardMeta('Восстановление пароля - Библиотека данных', 'Восстановление пароля в Библиотеке данных'),
    auth.setComputedFields,
    restore.setComputedFields,
    analytics.pageview,
    footer.setCopyrightYear
];



// WEBPACK FOOTER //
// ./signals/pages/auth/restore-password.js